<template>
  <div class="search-form-pagination">
    <el-pagination
      :current-page="form.formResult.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="form.formResult.pageSize"
      layout="total, prev, pager, next, sizes, jumper"
      :total="form.formResult.total"
      @current-change="onPageCurrentChange"
      @size-change="onPageSizeChange">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'wt-form-pagination',
  props: ['form'],
  methods: {
    onPageCurrentChange(pageNum) {
      //  切换页码
      this.form.pageData.currentPage = pageNum - 1
      this.$emit('request-form-list')
    },
    onPageSizeChange(pageSize) {
      //  切换页数
      this.form.pageData.pageSize = pageSize
      this.$emit('request-form-list')
    }
  }
}
</script>

<style scoped>

</style>
